import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-forgot-password',
  templateUrl: './password-reset-failed.page.html',
  styleUrls: ['./password-reset-failed.page.scss'],
})
export class PasswordResetFailedPage implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
